import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Empty } from "@/components/common";
import { api, fmtDateTime } from "@/lib/api";
import { cn } from "@/lib/utils";
import { Checkbox } from "@/components/ui/checkbox";
import { BulkDeleteBar, useSelection } from "@/components/BulkDelete";

export default function Notifiche() {
  const nav = useNavigate();
  const [d, setD] = useState({ items: [], unread: 0 });
  const load = () => api.get("/notifications").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const sel = useSelection(d.items);

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    if (n.link) nav(n.link);
    else load();
  };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="max-w-3xl" data-testid="notifications-page">
      <PageHeader title="Notifiche" subtitle={`${d.unread} non lette`}
        actions={d.unread > 0 && <Button variant="outline" onClick={readAll} data-testid="notifications-read-all-button"><CheckCheck className="mr-1.5 h-4 w-4" />Segna tutte come lette</Button>} />
      <BulkDeleteBar endpoint="/notifications/delete" selection={sel} total={d.items.length} onDone={load} prefix="notifications" noun="notifiche" />
      {d.items.length === 0 ? (
        <Empty icon={Bell} text="Nessuna notifica." testId="notifications-empty" />
      ) : (
        <ul className="divide-y overflow-hidden rounded-lg border bg-card">
          {d.items.map((n) => (
            <li key={n.id} className="flex items-start">
              <span className="pl-4 pt-4"><Checkbox checked={sel.has(n.id)} onCheckedChange={() => sel.toggle(n.id)} aria-label="Seleziona" data-testid={`notification-select-${n.id}`} /></span>
              <button onClick={() => open(n)} className={cn("flex w-full gap-3 px-5 py-4 text-left transition-colors hover:bg-muted/60", !n.read && "bg-primary/5")} data-testid={`notification-${n.id}`}>
                <span className={cn("mt-1.5 h-2 w-2 shrink-0 rounded-full", n.read ? "bg-transparent" : "bg-primary")} />
                <span className="min-w-0 flex-1">
                  <span className={cn("block text-sm", !n.read && "font-semibold")}>{n.title}</span>
                  {n.body && <span className="block truncate text-sm text-muted-foreground">{n.body}</span>}
                  <span className="mt-1 block text-xs text-muted-foreground">{fmtDateTime(n.created_at)}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
